import React from 'react';
import styled from 'styled-components';
import { Border, Color, Grid } from '../../app/StyleGuide';

const ProgressContainer = styled.div`
  display: flex;

  & > div {
    flex: 1;
    margin-right: ${Grid._4};
  }

  & > div:last-of-type {
    margin-right: 0;
  }
`;

const ProgressBar = styled.div<{
  percent: number;
  trackColor: string;
  fillColor: string;
}>`
  background: ${props => props.trackColor};
  padding: 0;
  margin: 0;
  height: ${Grid._3};
  position: relative;
  border-radius: ${Border.radius};

  &::before {
    background: ${props => props.fillColor};
    display: inline-block;
    content: '';
    top: 0;
    left: 0;
    height: ${Grid._3};
    width: ${props => props.percent}%;
    position: absolute;
    border-radius: ${Border.radius};
    transition: width 0.3s ease;
  }
`;

const PROGRESS_COLORS = {
  course: { track: Color.Green._10, fill: Color.Green._50 },
  pathway: { track: Color.Blue._10, fill: Color.Blue._50 },
} as const;

type ProgressProps = {
  variant: 'course' | 'pathway';
  segments: number[];
};

export function Progress({ variant, segments }: ProgressProps) {
  const { track, fill } = PROGRESS_COLORS[variant];
  const className = variant === 'course' ? 'tl-progress-bar' : 'wf-progress-bar';

  return (
    <ProgressContainer>
      {segments.map((percent, i) => (
        <ProgressBar key={i} className={className} percent={percent} trackColor={track} fillColor={fill} />
      ))}
    </ProgressContainer>
  );
}
